export const regex = {
	password: /((?=.*\d)(?=.*[A-z]).{6,})/,
	iban: /^(LU[0-9A-z ]+)/i,///[lL]{1,1}[uU]{1,1}[\dA-z]{2,2} ?[\dA-z]{4,4} ?[\dA-z]{4,4} ?[\dA-z]{4,4} ?[\dA-z]{4,4}(?: ?[\dA-z]{1,4})?(?: ?[\dA-z]{1,4})?$/
};


export const sportBetting = {
	url: {
		live: 'https://staging-carrusint.web.7platform.net/live',
		prematch: 'https://staging-carrusint.web.7platform.net/prematch'
	}
}
